<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('quran_programs.title'),
            subtitle: {
                first_text: $t('quran_programs.label'),
                first_href: '/',
                second_text: $t('quran_programs.title')
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-12 mb-3" v-for="(item, index) in eduPrograms" :key="index">
                    <QuranProgramCard :item="item" />

                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import Home from "../api/home";
import QuranProgramCard from "../components/QuranPrograms/QuranProgramCard.vue"


export default {
    async created() {
        let programs = await new Home().QuranPrograms({ per_page: 9, with: ['students'] });
        this.eduPrograms = programs.data;
    },
    components: {
        AppFooter, AppNavbar, PagesHero, QuranProgramCard
    },
    data() {
        return {
            eduPrograms: [],
        }
    }
}
</script>

<style scoped>
.row {
    margin-top: 40px;
}
</style>